import http from '@/utils/http';

export default {
	list: data => http({ url: '/api/admin/v1/contractOrder/list', data }),
	detail: data => http({ url: '/api/admin/v1/contractOrder/detail', data }),
	confirm: data => http({ url: '/api/admin/v1/contractOrder/confirm', data, tip: true }),
	customerOptions: data => http({ url: '/api/admin/v1/contractOrder/customerOptions', data }),
	addressOptions: data => http({ url: '/api/admin/v1/contractOrder/addressOptions', data }),
	generateEntrustNo: data => http({ url: '/api/admin/v1/contractOrder/generateEntrustNo', data }),
	entryContext: data => http({ url: '/api/admin/v1/contractOrder/entryContext', data }),
	batchPreview: data => http({ url: '/api/admin/v1/contractOrder/batchPreview', data }),
	batchCreate: data => http({ url: '/api/admin/v1/contractOrder/batchCreate', data, tip: true }),
};
